import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-highfreqimage',
  templateUrl: './highFreqImage.component.html',
  styleUrls: ['../../IconDesings.scss'],
})

export class HighFreqImageComponent {
  constructor() {
  }
}